import { BrandLocationData } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { ReactElement } from 'react';

export type LocationTableProps = {
  tableData: {
    key: string;
    value: string | number | boolean | undefined | null;
    renderCell?: (locationData: BrandLocationData) => ReactElement;
    locationData?: BrandLocationData;
  }[][];
};

const LocationTable = (props: LocationTableProps) => (
  <TableContainer>
    <Table size="small">
      <TableHead>
        <TableRow>
          {(props.tableData[0] ?? []).map(data => (
            <TableCell sx={{ fontWeight: 'bold' }} key={data.key}>
              {data.value}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {props.tableData.slice(1).map(rowData => (
          <TableRow
            key={rowData.map(data => data.value).join('-')}
            style={{
              backgroundColor: rowData[0]?.locationData?.locationListExclusionId
                ? 'pink'
                : undefined,
            }}
          >
            {rowData.map(cellData => (
              <TableCell key={cellData.key}>
                {cellData.renderCell && cellData.locationData
                  ? cellData.renderCell(cellData.locationData)
                  : cellData.value}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default LocationTable;
